import { User, AuthenticationError } from "../services/user.service";
import { TokenService } from "../services/storage.service";
import router from "../router";

const state = {
  authenticating: false,
  accessToken: TokenService.getToken(),
  refreshTokenPromise: null, // Holds the promise of the refresh token
  authenticationErrorCode: 0,
  authenticationError: "",
  data: false
};

const getters = {
  loggedIn: state => {
    return state.accessToken ? true : false;
  },

  authenticationErrorCode: state => {
    return state.authenticationErrorCode;
  },

  authenticationError: state => {
    return state.authenticationError;
  },

  authenticating: state => {
    return state.authenticating;
  },

  userLoaded: state => {
    return state.data ? true : false;
  },

  listPermissions: state => {
    return state.data.permissions || {};
  },
  hasAccess: state => permission => {
    if (!state.data || !state.data.permissions) return false;
    return state.data.permissions[permission] || false;
  },
  hasRole: state => roleName =>{
    if(!state.data || !state.data.role) return false;
    return state.data.role === roleName
  },
  getFullName: state =>{
    return (state.data.info.firstname + " "+state.data.info.lastname).trim();
  },
  getMyId: state =>{
    return state.data.id;
  },
  getInfo: state =>{
    return state.data.info;
    // return state.data.ingo
  },
  getRole: state =>{
    return state.data.role;
  },
  isNotSubcontractor: state =>{
    return !(state.data.role === 'subcontractor');
  },
  isEmployOrAdmin:state =>{
    return state.data.role === 'admin' || state.data.role === 'superadmin' ||  state.data.role === 'employee'||  state.data.role === 'manager';
  },
  isManagerOrAdmin:state =>{
    return state.data.role === 'admin' || state.data.role === 'superadmin' ||  state.data.role === 'manager';
  },
  isAdmin: state =>{
    return state.data.role === 'admin' || state.data.role === 'superadmin';
    //TODO: użyć tego wszędzie gdzie sprawdzamy czy admin lub super admin
  }

};

const actions = {
  async login({ commit }, { email, password, remember }) {
    commit("loginRequest");
    try {
      let token = await User.login(email, password, remember);
      commit("loginSuccess", token);
      // Redirect the user to the page he first tried to visit or to the home view
      router.push(router.history.current.query.redirect || "/dashboard");
      return true;
    } catch (e) {
      if (e instanceof AuthenticationError) {
        commit("loginError", { errorCode: e.errorCode, errorMessage: e.message });
      }
      return false;
    }
  },
  async load({ commit }) {
    try {
      let userData = await User.load();
      commit("userDataSet", userData);
      return true;
    } catch (e) {
      //TODO: wyświetlić info jako Toast
      User.logout();
      if (e instanceof AuthenticationError) {
        commit("loginError", { errorCode: e.errorCode, errorMessage: e.message });
      }
      router.push("/login");
      return false;
    }
  },
  async update({ commit }, form){
    let userData = await User.update(form);
    commit("userDataSet", userData);
  },
  refreshToken({ commit, state }) {
    // If this is the first time the refreshToken has been called, make a request
    // otherwise return the same promise to the caller
    if (!state.refreshTokenPromise) {
      const p = User.refreshToken();
      commit("refreshTokenPromise", p);
      // Wait for the UserService.refreshToken() to resolve. On success set the token and clear promise
      // Clear the promise on error as well.
      p.then(
        response => {
          commit("refreshTokenPromise", null);
          commit("loginSuccess", response);
        },
        (/*error*/) => {
          commit("refreshTokenPromise", null);
        }
      );
    }

    return state.refreshTokenPromise;
  },
  logout({ commit }) {
    User.logout();
    commit("logoutSuccess");
    router.push("/login");
    window.location.reload();//<-- dumy clean store vuex
  }
};

const mutations = {
  loginRequest(state) {
    state.authenticating = true;
    state.authenticationError = "";
    state.authenticationErrorCode = 0;
  },

  loginSuccess(state, accessToken) {
    state.accessToken = accessToken;
    state.authenticating = false;
  },

  loginError(state, { errorCode, errorMessage }) {
    state.accessToken = false;
    state.authenticating = false;
    state.authenticationErrorCode = errorCode;
    state.authenticationError = errorMessage;
    state.data = false;
  },

  logoutSuccess(state) {
    state.accessToken = "";
    state.data = false;
  },

  userDataSet(state, payload) {
    state.data = payload;
  },

  refreshTokenPromise(state, promise) {
    state.refreshTokenPromise = promise;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
